import React from 'react'
import { CustomDialogContent } from '..'
import { createStyles, makeStyles, Typography, Theme } from '@material-ui/core'

interface IHowToAddDoseModal {
  onCloseInfoModal: () => void
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    contentContainer: {
      lineHeight: 2,
      textAlign: 'justify',
      margin: theme.spacing(2, 0),
    },
    strong: {
      fontWeight: 'bold',
    },
  })
)

export const HowToAddDoseModal = ({ onCloseInfoModal }: IHowToAddDoseModal) => {
  const classes = useStyles()
  return (
    <CustomDialogContent title="How do I add a dose?" onCancel={onCloseInfoModal}>
      <Typography variant="h5" className={classes.contentContainer}>
        {`Adding a dose is pretty simple.`}
      </Typography>
      <Typography variant="body1" className={classes.contentContainer}>
        1. Click on the plus + button in the app or in{' '}
        <span className={classes.strong}>Add Dose</span> option.
      </Typography>
      <Typography variant="body1" className={classes.contentContainer}>
        2. Write down the title for the dose
      </Typography>
      <Typography variant="body2" className={classes.contentContainer}>
        {`Example: 90's Hits Dose.`}
      </Typography>
      <Typography variant="body1" className={classes.contentContainer}>
        3. Write down the <span className={classes.strong}>description</span> of the
        dose. It could be an activity you want yourself and your friends to do, a
        challenge you dare your friends to complete, or any experience you would like
        them and you to share.
      </Typography>
      <Typography variant="body2" className={classes.contentContainer}>
        Example: Create a playlist on Spotify with 10 of the best 90&apos;s Hits.
        Share it with all of us!
      </Typography>
      <Typography variant="body1" className={classes.contentContainer}>
        If you don&apos;t feel inspired, you can click on the{' '}
        <span className={classes.strong}>Find Suggestions</span> button to get a full
        list of possible doses you could create.
      </Typography>
      <Typography variant="body1" className={classes.contentContainer}>
        4. Select to which of your groups you want the dose to be added.
      </Typography>
      <Typography variant="body1" className={classes.contentContainer}>
        5. Hit <span className={classes.strong}>Submit</span> and that&apos;s it.
      </Typography>
    </CustomDialogContent>
  )
}
